import { createContext, useContext } from "react";

/**
 * The panel-level slot a page pins floating chrome into (the mobile opt-in pill): a sibling of
 * the scroll region, anchored to the panel's bottom edge, so what goes in it stays put whatever
 * the content's height or scroll position. `null` until the layout has mounted it.
 */
export const FloatingSlotContext = createContext<HTMLElement | null>(null);

export const useFloatingSlot = () => useContext(FloatingSlotContext);
